module.exports = __webpack_public_path__ + "img/close_ico_5.d289f766.svg";